import wixData from 'wix-data';
import wixWindow from 'wix-window';
import { cart } from 'wix-stores';

let total = 0;
let giftFlag = 0;
let gift;
let maxGift;

$w.onReady(async function () {
    const gifts = await wixData.query("gifts").ascending("amount").include("gift").find();
    cart.onChange(async (changedCart) => {
        total = changedCart.totals.total;
        console.log("***cart changed");

        if (total < gifts.items[0].amount) {
            console.log("empty");
            for (let k = 0; k < changedCart.lineItems.length; k++) {
                let cartItem = changedCart.lineItems[k];
                if (Number(cartItem.price) === 0) {
                    await cart.removeProduct(Number(cartItem.id))
                        .then(() => {
                            console.log("item removed " + k);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
        }

        if (total === 0) {
            console.log("empty");
            for (let d = 0; d < changedCart.lineItems.length; d++) {
                let cartItem = changedCart.lineItems[d];
                if (Number(cartItem.price) === 0) {
                    await cart.removeProduct(Number(cartItem.id))
                        .then(() => {
                            console.log("item removed " + d);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
        } else {            
            for (let i = 0; i < gifts.items.length; i++) {
                //lightbox
                gift = gifts.items[i];
                maxGift = gift.amount;

                //console.log("giftFlag: " + giftFlag);                
                //console.log("gift.amount: " + gift.amount);
                //console.log("gift.name: " + gift.name);

                if (giftFlag === 0 && total < gift.amount && total + gift.announcement > gift.amount) {
                    console.log("lightbox");
                    wixWindow.openLightbox("gifts", gift);
                    console.log("break lightbox");
                }
            }

            for (let j = gifts.items.length - 1; j >= 0; j--) {
                /*console.log("giftFlag: " + giftFlag);
                console.log("maxGift: " + maxGift);
                console.log("total: " + total);
                console.log("gift.amount: " + gift.amount);
                console.log("gift.name: " + gift.name);*/

                if (giftFlag === 2) {
                    giftFlag = 0;
                    console.log("break giftFlag ===3")
                    break;
                }

                gift = gifts.items[j];
                maxGift = gift.amount;
                console.log("maxGift: " + maxGift);
                console.log("total: " + total);
                if (total >= maxGift) {
                    console.log("remove & add");
                    //remove
                    if (giftFlag === 0) {
                        for (let d = 0; d < changedCart.lineItems.length; d++) {
                            giftFlag = 1;
                            let cartItem = changedCart.lineItems[d];
                            if (Number(cartItem.price) === 0) {
                                await cart.removeProduct(Number(cartItem.id))
                                    .then(() => {
                                        console.log("item removed " + d);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            }
                        }
                    }

                    if (giftFlag === 1) {
                        //add
                        let found = false;
                        for (let x = 0; x < changedCart.lineItems.length; x++) {
                            let cartTempItem = changedCart.lineItems[x];
                            if (Number(cartTempItem.price) === 0) {
                                found = true;
                            }
                        }
                        if (!found) {
                            const products = [{
                                "productId": gift.gift._id,
                                "quantity": 1
                            }]
                            await cart.addProducts(products)
                                .then(() => {
                                    console.log("gift added");
                                    giftFlag = 2;
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                        }
                    }

                    if (giftFlag === 2) {
                        console.log("break 107");
                        break;
                    }
                }
            }
        }
    })
})